import { err, errAsync, ok, okAsync } from "neverthrow";

import { InitError, NotFoundError } from "./errors";
import { attachEventHandlerToElement } from "./helper/attach-event-handler-to-element";
import { getElementsByText } from "./helper/get-elements-by-text";
import { getEmailFormElements } from "./helper/get-email-form-elements";
import { getHookMap } from "./helper/get-hook-map";
import { getIsFormAutomatic } from "./helper/get-is-form-automatic";
import { injectMetaPixel } from "./helper/inject-meta-pixel";
import { triggerMetaEvent } from "./helper/trigger-meta-event";
import {
  Action,
  ActionDataEnum,
  ActionTypeEnum,
  DataItem,
  ElementTypeEnum,
} from "./types";

document.addEventListener("DOMContentLoaded", () => {
  async function initialize(hookKey: string) {
    await (
      await getHookMap(hookKey)
    )
      .andThen((response) => {
        if (response.ok) {
          return ok(response.data);
        } else {
          return err(new InitError(response.errorMessage));
        }
      })
      .andThen((actions) => {
        if (!actions) {
          return err(new InitError("Hook does have no actions."));
        }

        for (const action of actions as Action[]) {
          if (
            action.type == ActionTypeEnum.BREVO_CONTACT &&
            getIsFormAutomatic(action)
          ) {
            const formElements = getEmailFormElements();

            for (const element of formElements) {
              const attachEventHandlerToIDResult = attachEventHandlerToElement(
                element,
                "",
                ActionTypeEnum.BREVO_CONTACT,
                action.key,
              );

              if (attachEventHandlerToIDResult.isErr()) {
                console.warn(attachEventHandlerToIDResult.error);
              }
            }

            continue;
          }

          if (!action.elements) {
            return err(new InitError("Action does not have any elements."));
          }

          const htmlElements: HTMLElement[] = [];

          for (const element of action.elements) {
            if (element.type === ElementTypeEnum.ID) {
              const htmlElement = document.getElementById(element.value);

              if (!htmlElement) {
                return err(
                  new NotFoundError(
                    `Could not find an element with ID ${element.value}.`,
                  ),
                );
              }

              htmlElements.push(htmlElement);
            } else if (element.type === ElementTypeEnum.LABEL) {
              htmlElements.push(...getElementsByText(element.value));
            }

            for (const htmlElement of htmlElements) {
              const attachEventHandlerToIDResult = attachEventHandlerToElement(
                htmlElement,
                element.value,
                action.type,
                action.key,
              );

              if (attachEventHandlerToIDResult.isErr()) {
                console.warn(attachEventHandlerToIDResult.error);
              }
            }
          }
        }

        return ok(actions);
      })
      .asyncAndThen((actions) => {
        const metaEventAction = (actions as Action[]).find((action) => {
          return action.type === ActionTypeEnum.META_EVENT;
        });

        if (!metaEventAction) {
          return okAsync(undefined);
        }

        const pixelId = (metaEventAction.data as DataItem[]).find((item) => {
          return item.key === ActionDataEnum.PIXEL_ID;
        });

        if (!pixelId) {
          return errAsync();
        }

        injectMetaPixel(pixelId.value);

        if (metaEventAction) {
          triggerMetaEvent(metaEventAction.key, "ViewContent");
        }

        return okAsync(undefined);
      })
      .mapErr((error) => {
        console.error(error);
      });
  }

  (window as any).trackhooki = {
    init: initialize,
  };

  document.dispatchEvent(new Event("trackhooki:ready"));
});
